import { apiGetAuth, apiPostAuth } from '@/utils/api'
import { API_EMPLOYEE_EXISTING_SYNC } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  existing_sync_list: {
    isLoading: false,
    data: {}
  },
  detail_existing_sync: {
    isLoading: false,
    data: {}
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_EXISTING_SYNC_LIST": (state, payload) => {
    state.existing_sync_list = payload
  },
  "SET_DETAIL_EXISTING_SYNC": (state, payload) => {
    state.detail_existing_sync = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getEmployeeExistingSyncList(context, payload) {
    try {
      context.commit('SET_EXISTING_SYNC_LIST', { isLoading: true })
      const response = await apiGetAuth(API_EMPLOYEE_EXISTING_SYNC.LIST, payload)
      context.commit('SET_EXISTING_SYNC_LIST', {
        isLoading: false,
        data: response?.data
      })
      context.commit('SET_META_FILTER', payload)
    } catch (err) {
      context.commit('SET_EXISTING_SYNC_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailExistingSyncById(context, id) {
    try {
      context.commit('SET_DETAIL_EXISTING_SYNC', { isLoading: true })
      const response = await apiGetAuth(API_EMPLOYEE_EXISTING_SYNC.BY_ID(id))
      context.commit('SET_DETAIL_EXISTING_SYNC', {
        isLoading: false,
        data: response?.data?.data
      })
      return response?.data?.data
    } catch (err) {
      context.commit('SET_DETAIL_EXISTING_SYNC', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
      return null
    }
  },
  async uploadRevisionEmployeeExistingSync(context, payload) {
    try {
      const response = await apiPostAuth(API_EMPLOYEE_EXISTING_SYNC.UPLOAD_REVISION, payload)
      return response?.data
    } catch (err) {
      notificationDanger(err?.response?.data?.message || 'Gagal mengunggah revisi data karyawan')
      throw err
    }
  },
  async saveExistingEmployeeSync(context, companyCode) {
    try {
      // Tarik data karyawan existing dari Core -- bisa lama (network + mapping banyak baris), timeout dilonggarin.
      const response = await apiPostAuth(API_EMPLOYEE_EXISTING_SYNC.SAVE(companyCode), null, 180000)
      return response?.data
    } catch (err) {
      notificationDanger(err?.response?.data?.message || 'Gagal memulai sync karyawan existing')
      throw err
    }
  }
}

const getters = {
  get_existing_sync_list: state => {
    return state.existing_sync_list
  },
  get_detail_existing_sync: state => {
    return state.detail_existing_sync
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
